//==============================================
// CHECK IF ITS EDGE BROWSER
//==============================================
export function isEdgeBrowser(userAgent: string) {

    return userAgent.indexOf('Edg/') > -1
}
